import React, { useState } from 'react';
import * as QueryString from 'query-string';
import { Form, Formik } from 'formik';

import {useDispatch, useSelector } from 'react-redux';
import { useHistory} from 'react-router-dom';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';

import TextInput from 'web/components/form-elements/TextInput';
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner';
import { changePassword } from 'redux/actions/auth';
import { subAccountActivation } from 'redux/actions/accountSetting';
import {
  INITIAL_VALUES,
  VALIDATION_SCHEMA,
} from 'web/components/utils/confirmPasswod';
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";
import { Container,SectionB } from '../confirm-password/confirmPasswordStyle';
const ConfirmPassword = ({ match, location }) => {

  let history = useHistory();
  const dispatch = useDispatch();
  const [acknowledgeState, setAcknowledgeState] = useState(false);

  const [alertCallBack, setAlertCallBack] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';
  const params = QueryString.parse(location.search);
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  const changePassHandler = async (props) => {
    let data = {
      password: props.values.password,
      confirmPassword: props.values.confirmPassword,
    };
    let response;
    if (params.role) {
      response = await dispatch(subAccountActivation(data, params.token));
    } else {
      response = await dispatch(changePassword(data, params.token));
    }
    if (response.status === "SUCCESS") {
      setAlertCallBack("confirmPassword")
      setModalContent(response.message);
      setModalLink('');
      toggleModal();
    } else {
      if (response.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in')
        window.location.reload(false);
      } else if (response.success) {
        setAlertCallBack("confirmPassword")
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
      else {
        setAlertCallBack('')
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  };

  const [tooltipPasswordIcon, setTooltipPasswordIcon] = useState(false);
  const passwordIcon = (infoTxt) => {
    return <>
      <img
        id="PasswordIcon"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipPasswordIcon}
        target="PasswordIcon"
        toggle={() =>
          setTooltipPasswordIcon(!tooltipPasswordIcon)
        }
      >
        <span style={{ 'Display': 'block', fontSize: '14px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>Password must have:</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least 8 characters.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one capital letter.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one lowercase letter.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one special characters.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one number</span>
      </Tooltip>
    </>
  }
  return (
    <>
      <Container>
        {loaderVisible && <Spinner />}
        <SectionB>
          <div className="centered-form-card">
            <Formik
              initialValues={INITIAL_VALUES}
              validationSchema={VALIDATION_SCHEMA}
              onSubmit={(values) => { }}>
              {(props) => {
                const { isValid, dirty } = props;
                return (
                  <>
                    <Form>
                      <div>
                        {params.role ? <h3>Set Password</h3> : <h3>Forgot Password</h3>}

                        <p>Please select a password for your PalletTrader Account.</p>
                        <div>
                          <p>New Password<span className="star">*</span>{passwordIcon('Password must contain 8 characters, one uppercase, one lowercase, one number and one special case character.')}</p>
                          <TextInput
                            name='password'
                            type='password'
                            placeholder='(At least 8 characters)'
                          />

                        </div>
                        <div>
                          <p>Confirm Password<span className="star">*</span></p>
                          <TextInput
                            name='confirmPassword'
                            type='password'
                            placeholder='(At least 8 characters)'
                          />
                        </div>

                        {params.role ? (<>
                          <CheckboxInput
                            name="acknowledge"
                            label="I hereby acknowledge and agree to this website's terms and conditions."
                            handleSelect={(e) => {
                              if (e === false) {
                                setAcknowledgeState(true)
                              } else {
                                setAcknowledgeState(false)
                              }

                            }}
                          />
                          <Button
                            type='app-green-button'
                            handleClick={() => {
                              changePassHandler(props);
                            }}
                            disabled={!(isValid && dirty && acknowledgeState)}
                          >
                            Confirm
                          </Button>
                        </>) : <Button
                          type='app-green-button'
                          handleClick={() => {
                            changePassHandler(props);
                          }}
                          disabled={!(isValid && dirty)}>
                            Confirm
                      </Button>}
                      </div>
                    </Form>
                  </>
                );
              }}

            </Formik>
          </div>
        </SectionB>

      </Container>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
        alertType={alertCallBack}
        callBackAlert={(val) => {
          if (val === 'confirmPassword')
            history.push('/sign-in');
            window.location.reload(false);
        }}
      />
    </>
  );
};

export default ConfirmPassword;